// TODO: Remove dependency on vh and vw as much as possible. Use percentages instead. Esp. in portrait views.

import { useEffect, useState } from "react";
import LandscapeLayout from "./components/landscape-layout/LandscapeLayout";
import PortraitLargeLayout from "./components/portrait-large-layout/PortraitLargeLayout";
import PortraitMediumLayout from "./components/portrait-medium-layout/PortraitMediumLayout";
import PortraitSmallLayout from "./components/portrait-small-layout/PortraitSmallLayout";
import PortraitXSLayout from "./components/portrait-xs-layout/PortraitXSLayout";

function getDisplayLayout({ height, width }) {
  if (width >= 950 && width >= height && height >= 650) {
    return <LandscapeLayout />;
  } else if (width >= 560) {
    return <PortraitLargeLayout />;
  } else if (width >= 330) {
    return <PortraitMediumLayout />;
  } else if (width >= 240) {
    return <PortraitSmallLayout />;
  } else {
    return <PortraitXSLayout />;
  }
}

function App() {
  const [currentDims, setCurrentDims] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const [timeoutId, setTimeoutId] = useState(false);

  /**
   * The following callback uses a debouncing optimization that makes it execute the state update
   * only when a considerable resize is finished (it waits for some interval before update).
   *
   * @see https://bencentra.com/code/2015/02/27/optimizing-window-resize.html
   */
  useEffect(() => {
    const handleResize = () => {
      clearTimeout(timeoutId);
      setTimeoutId(
        setTimeout(() => {
          setCurrentDims({
            height: window.innerHeight,
            width: window.innerWidth,
          });
        }, 300)
      );
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [timeoutId]);

  return getDisplayLayout(currentDims);
}

export default App;
